<template>
  <modal
    :show.sync="showConfirmation"
    header-classes="justify-content-center"
    footer-classes="px-4 py-3"
    class="modal-default"
    @close="handleClose()"
  >
    <template>
      <p
        slot="header"
        class="title"
        style="margin-top: 24px"
      >
        {{ text }}
      </p>
      <div class="row d-flex justify-content-center">
        <base-button
          size="sm"
          type="primary"
          @click="handleClose()"
        >
          Close
        </base-button>
      </div>
    </template>
  </modal>
</template>

<script>
import {Modal} from "@/components/index";

export default {
  name: "message-box",
  components: {
    Modal,
  },
  props: {
    text: {
      type: String,
      default: "Are you sure?",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showConfirmation: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("closeClicked");
    },
  },
};
</script>
